import Vue from 'vue';
import OneCourse from './_components/OneCourse';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(timezone);
dayjs.extend(utc);

new Vue({
    components: {
        OneCourse,
    },
    el: '#courses',
    data: {
        courses,
        user,
        currentTime: null,
        enrollmentTimeout: null,
    },
    computed: {
        regStatus() {
            if (!this.currentTime) {
                return null;
            }

            if (this.enrollmentEnds.isBefore(this.currentTime)) {
                return this.REGISTRATION_PAST;
            } else if (this.enrollmentStarts.isAfter(this.currentTime)) {
                return this.REGISTRATION_FUTURE;
            } else {
                return this.REGISTRATION_NOW;
            }
        }
    },
    methods: {
        setEnrollmentTimeout() {
            let vue = this;
            this.currentTime = dayjs().tz(this.timezone);
            // console.debug('currentTime', this.currentTime.format('YYYY-MM-DD HH:mm:ss'));
            // console.debug('regStatus', this.regStatus);
            if (this.enrollmentTimeout) {
                clearTimeout(this.enrollmentTimeout);
            }
            if (this.regStatus !== this.REGISTRATION_FUTURE) {
                return;
            }
            if (this.enrollmentStarts.diff(this.currentTime, 'day') !== 0) {
                return;
            }
            let ms = null;
            if (this.enrollmentStarts.diff(this.currentTime, 'hour')) {
                ms = 3600000;
            } else if (this.enrollmentStarts.diff(this.currentTime, 'minute')) {
                ms = 60000;
            } else {
                ms = 1000;
            }

            // console.debug('setEnrollmentTimeout', ms);
            this.enrollmentTimeout = setTimeout(function () {
                vue.setEnrollmentTimeout();
            }, ms);
        },
    },
    created() {
        this.REGISTRATION_PAST = 1;
        this.REGISTRATION_NOW = 2;
        this.REGISTRATION_FUTURE = 3;

        this.timezone = 'America/New_York';

        this.enrollmentStarts = dayjs.tz(enrollmentStarts, this.timezone);
        // console.debug('enrollmentStarts', this.enrollmentStarts.format('YYYY-MM-DD HH:mm:ss'));
        this.enrollmentEnds = dayjs.tz(enrollmentEnds, this.timezone);
        // console.debug('enrollmentEnds', this.enrollmentEnds.format('YYYY-MM-DD HH:mm:ss'));

        this.setEnrollmentTimeout();
    },
});
